import angular from "angular";

import AdminBookingsModuleRouting from "./admin-bookings.module.routing";

export default angular
  .module("vt-admin-bookings", [])
  .config(AdminBookingsModuleRouting);
